import {
  USERS_REQUEST,
  USERS_SUCCESS,
  USERS_FAILURE,
  USER_SAVE_REQUEST,
  USER_SAVE_SUCCESS,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_CLEAN,
  CRM_USER_SUCCESS,
  CRM_USER_FAILURE,
  CRM_DEPARTMENTS_REQUEST,
  CRM_DEPARTMENTS_SUCCESS,
  CRM_DEPARTMENTS_FAILURE,
  CRM_DEPARTMENTS_CLEAN,
  CRM_TEAMS_REQUEST,
  CRM_TEAMS_SUCCESS,
  CRM_TEAMS_FAILURE,
  CRM_TEAMS_CLEAN,
  USER_UPDATE,
} from './types';

const initialState = {
  list: [],
  totalCount: 0,
  loading: false,
  error: false,
  current: false,
  crmUser: false,
  crmDepartments: false,
  crmTeams: false,
  passwordReseting: false,
  changingUserStatus: false,
  userUpdate: false,
};

const crmDepartmentsFailure = {
  loadingError: true,
  data: [
    {
      id: null,
      type: 'department',
      attributes: {
        name: 'Error loading CRM departments!',
        sso_role_id: 'error',
      },
    },
  ],
};

const crmTeamsFailure = {
  loadingError: true,
  data: [
    {
      id: null,
      type: 'team',
      attributes: {
        name: 'Error loading CRM teams!',
        sso_role_id: 'error',
      },
    },
  ],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USERS_REQUEST:
      return {
        ...state,
        list: [],
        loading: 'list',
        error: false,
        current: false,
        crmUser: false,
      };
    case USER_SAVE_REQUEST:
      return { ...state, loading: 'save', error: false };
    case USER_UPDATE_REQUEST:
      return { ...state, loading: 'update', error: false };
    case USERS_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case USERS_SUCCESS: {
      return {
        ...state,
        list: action.payload.result,
        totalCount: action.payload.result_count,
        loading: false,
        error: false,
      };
    }
    case USER_SAVE_SUCCESS:
    case USER_UPDATE_SUCCESS:
      return { ...state, current: false, loading: false, error: false };
    case USER_CLEAN:
      return { ...state, current: false, crmUser: false };
    case CRM_USER_SUCCESS:
      return { ...state, crmUser: action.payload };
    case CRM_USER_FAILURE:
      return { ...state, crmUser: false };
    case CRM_DEPARTMENTS_REQUEST:
    case CRM_DEPARTMENTS_CLEAN:
      return { ...state, crmDepartments: false };
    case CRM_DEPARTMENTS_SUCCESS:
      return { ...state, crmDepartments: action.payload };
    case CRM_DEPARTMENTS_FAILURE:
      return { ...state, crmDepartments: crmDepartmentsFailure };
    case CRM_TEAMS_REQUEST:
    case CRM_TEAMS_CLEAN:
      return { ...state, crmTeams: false };
    case CRM_TEAMS_SUCCESS:
      return { ...state, crmTeams: action.payload };
    case CRM_TEAMS_FAILURE:
      return { ...state, crmTeams: crmTeamsFailure };
    case USER_UPDATE:
      return { ...state, userUpdate: action.payload };
    default:
      return state;
  }
}
